var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 29,
    viewBox: "0 0 17 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.944 0.423853C15.3569 -0.141284 14.4064 -0.141284 13.8208 0.423853L1.40455 12.4055C0.231848 13.5372 0.231848 15.3731 1.40455 16.5048L13.9109 28.5757C14.492 29.135 15.4305 29.1426 16.0191 28.5905C16.6212 28.0269 16.6272 27.0976 16.0356 26.5253L4.58935 15.4803C4.00225 14.9138 4.00225 13.9965 4.58935 13.43L15.944 2.47283C16.5311 1.90769 16.5311 0.990426 15.944 0.423853Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.2e4a792ff38943f109c08e00baafb948.svg";
export { ForwardRef as ReactComponent };